import { render, staticRenderFns } from "./DeletePropertyCompany.vue?vue&type=template&id=1dc680c0"
import script from "./DeletePropertyCompany.vue?vue&type=script&lang=js"
export * from "./DeletePropertyCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports